import polyglotI18nProvider from "ra-i18n-polyglot";
import russianMessages from "ra-language-russian";
import polishMessages from "ra-language-polish";

const newPolishMessages = {
  ...polishMessages,
  usermenu: {
    login: "Zaloguj się",
  },
  ra: {
    ...polishMessages.ra,
    configurable: {
      customize: "Dostosuj",
    },
    page: {
      ...polishMessages.ra.page,
      empty: 'Brak rekordów w tabeli "%{name}"',
    },
    action: {
      ...polishMessages.ra.action,
      clear_array_input: "Wyczyść wszystko",
      move_up: "Przenieś w górę",
      move_down: "Przenieś w dół",
    },
    message: {
      ...polishMessages.ra.message,
      clear_array_input: "Wszystkie elementy zostaną usunięte",
    },
  },
  login: {
    login: "Logowanie",
    signIn: "Zaloguj się",
    signUp: "Rejestracja",
    registrationInvitation: "Nie masz jeszcze konta?",
    signInError: "Nieprawidłowy login lub hasło",
    form: {
      email: {
        label: "Email",
        errors: {
          email: "Nieprawidłowy email",
          maxLength: "Email musi być krótszy niż 60 znaków",
        },
      },
      password: {
        label: "Hasło",
        errors: {
          regex:
            "Hasło musi zawierać cyfry i litery, mieć długość od 8 do 16 znaków",
        },
      },
    },
  },
  resources: {
    users: {
      name: "Użytkownik |||| Użytkownicy",
      fields: {
        password: "Hasło",
        role: "Rola",
      },
    },
    mainPage: {
      name: "Ustawienia główne",
    },
    socials: {
      name: "Media społecznościowe",
    },
    banners: {
      name: "Banery",
    },
    benefits: {
      name: '"Zalety"',
    },
    forms: {
      name: "Opis usługi",
    },
    services: {
      name: "Strony usług",
    },
    layout: {
      name: "Layout",
    },
    faq: {
      name: "FAQ",
    },
    about: {
      name: '"O nas"',
    },
    popular: {
      name: '"Popularne problemy"',
    },
  },
  mainPage: {
    name: "Strona główna",
    title: "Tytuł",
    banner: "Wybierz baner z listy",
    about: 'Wybierz sekcję "O nas" z listy',
    benefits: 'Wybierz sekcję "Zalety" z listy',
    popular: 'Wybierz sekcję "Popularne problemy" z listy',
  },
  socials: {
    title: "Nazwa",
    link: "Link",
  },
  banners: {
    title: "Tytuł",
    subtitle: "Podtytuł",
    slogans: "Slogany",
    slogan: "Slogan",
  },
  benefits: {
    title: "Tytuł",
    subtitle: "Podtytuł",
    description: "Opis",
    benefits: "Zalety",
    benefitTitle: "Tytuł",
    benefitDescription: "Opis",
  },
  forms: {
    video: "Id video",
    title: "Tytuł",
    subtitle: "Podtytuł",
    description: "Opis",
    article: "Opis alternatywnych usług",
    extraButtons: "Dodatkowe przyciski",
    buttonTitle: "Nazwa przycisku",
    buttonLink: "Link do usługi",
  },
  services: {
    cover: "Okładka",
    banner: "Baner",
    forms: "Opis usługi",
    form: "Wybierz opis usługi z listy",
    serviceName: "Nazwa usługi",
    coverTitle: "Tytuł okładki",
    coverSubTitle: "Podtytuł okładki",
    mainPriceTitle: "Tytuł ceny",
    mainPriceSubtitle: "Podtytuł ceny",
    prices: "Ceny",
    categoryTitle: "Kategoria",
    priceList: "Lista cen",
    name: "Nazwa usługi",
    price: "Koszt usługi",
  },
  layout: {
    phone: "Telefon",
    email: "E-mail",
    copyright: "Copyright",
    slogan: "Slogan",
    options: "Wybrane usługi",
    option: "Nazwa usługi",
    link: "Link do usługi",
  },
  faq: {
    banner: "Baner",
    title: "Tytuł",
    subtitle: "Podtytuł",
    questions: "Pytania i odpowiedzi",
    question: "Pytanie",
    answer: "Odpowiedź",
  },
  about: {
    title: "Tytuł",
    subtitle: "Podtytuł",
    description: "Opis",
    companyInfo: "Informacje o firmie",
    optionTitle: "Tytuł",
    optionDescription: "Opis",
  },
  popular: {
    title: "Tytuł",
    subtitle: "Podtytuł",
    description: "Opis",
    services: "Lista usług",
    problem: "Problem",
    service: "Link do usługi",
  },
  menuGroups: {
    templates: "Szablony",
    modules: "Moduły",
  },
  creators: {
    tabs: {
      form: "Edycja",
      preview: "Podgląd",
    },
  },
  imageCrop: {
    title: "Kadrowanie i rozmiar obrazu",
    open: "Kadruj / zmień rozmiar",
    mouseHint:
      "Przeciągnij ramkę, aby wybrać fragment; ciągnij za narożniki, aby zmienić jej rozmiar (proporcje zostają).",
    mouseHintFree:
      "Przeciągnij ramkę, aby wybrać fragment; ciągnij za narożniki lub krawędzie, aby zmienić jej rozmiar.",
    size: "Rozmiar docelowy",
    width: "Szerokość",
    height: "Wysokość",
    lockedAspect: "Proporcje 1:1 – ikona na stronie jest kwadratowa",
    invalidSize: "Podaj liczbę całkowitą od 1 do %{max} px",
    sourceSize: "Oryginał: %{width}×%{height} px",
    areaSize: "zaznaczony obszar: %{width}×%{height} px",
    upscaleWarning:
      "Zaznaczony obszar jest mniejszy niż rozmiar docelowy – obraz zostanie powiększony i może być nieostry.",
    renderError: "Nie udało się przyciąć obrazu: %{error}",
    loadError: "Nie udało się wczytać obrazu do kadrowania: %{error}",
    apply: "Zastosuj",
    keepOriginal: "Zostaw bez kadrowania",
    currentSize: "Rozmiar: %{width}×%{height} px",
    cropped: "Wykadrowano",
    serverResizeHint:
      "Bez kadrowania serwer przytnie obraz do %{width}×%{height} px (środek)",
    presets: {
      standard: "Standard 16:9",
      bannerDesktop: "Szeroki baner",
      photo43: "Zdjęcie 4:3",
      square: "Kwadrat",
      serviceCard: "Karta usługi",
      icon: "Ikona",
      iconRetina: "Ikona HD",
      custom: "Własny rozmiar",
      free: "Dowolny kadr",
    },
  },
  errors: {
    notFound: "Nie znaleziono rekordu",
    unauthorized: "Wymagane zalogowanie",
    noHasPermissions: "Brak uprawnień do wykonania tej operacji",
    invalidRequest: "Nieprawidłowe dane formularza",
  },
  customErrors: {
    invalidEmailOrPassword: "Nieprawidłowy email lub hasło",
  },
  servicesReorder: {
    menu: "Zmień kolejność",
    title: "Kolejność stron usług",
    subtitle:
      "Przeciągnij usługi, aby zmienić ich kolejność w karuzeli i listach rozwijanych na stronie.",
    saving: "Zapisywanie...",
    notifications: {
      success: "Kolejność została zapisana",
      error: "Nie udało się zapisać kolejności",
      loadError: "Nie udało się wczytać listy usług",
    },
  },
  preview: {
    menu: "Kreator strony usługi",
    title: "Kreator strony usługi",
    subtitle:
      "Utwórz baner, opisy usług i samą usługę w jednym formularzu, bez przełączania się między sekcjami.",
    sections: {
      service: "Usługa",
      banner: "Baner",
      forms: "Opisy usług (sekcje zamówienia)",
    },
    metaHint:
      "Te pola nie są widoczne na stronie – służą do tytułu karty i SEO.",
    serviceCard: "Karta usługi w karuzeli (350×250 px)",
    save: "Zapisz stronę usługi",
    saveExisting: "Zapisz zmiany",
    selector: {
      label: "Istniejąca strona usługi",
      new: "Nowa strona usługi",
    },
    notifications: {
      success: "Strona usługi została zapisana",
      error: "Błąd zapisu: %{error}",
      loadError: "Nie udało się wczytać strony usługi: %{error}",
      partial:
        "Częściowo utworzono: baner (%{banner}), opisy usług (%{forms}). Popraw dane i zapisz ponownie albo dokończ ręcznie w sekcjach Banery/Opis usługi/Strony usług.",
    },
  },
  mainPageCreator: {
    menu: "Kreator strony głównej",
    title: "Kreator strony głównej",
    subtitle:
      "Utwórz baner, sekcję \"O nas\", \"Zalety\" i \"Popularne problemy\" w jednym formularzu, bez przełączania się między sekcjami.",
    save: "Zapisz stronę główną",
    saveExisting: "Zapisz zmiany",
    selector: {
      label: "Istniejąca strona główna",
      new: "Nowa strona główna",
    },
    notifications: {
      success: "Strona główna została zapisana",
      error: "Błąd zapisu: %{error}",
      loadError: "Nie udało się wczytać strony głównej: %{error}",
    },
  },
  faqCreator: {
    menu: "Kreator FAQ",
    title: "Kreator FAQ",
    subtitle:
      "Utwórz baner i pytania FAQ w jednym formularzu, bez przełączania się między sekcjami.",
    save: "Zapisz stronę FAQ",
    saveExisting: "Zapisz zmiany",
    selector: {
      label: "Istniejąca strona FAQ",
      new: "Nowa strona FAQ",
    },
    notifications: {
      success: "Strona FAQ została zapisana",
      error: "Błąd zapisu: %{error}",
      loadError: "Nie udało się wczytać strony FAQ: %{error}",
    },
  },
};

const newRussianMessages = {
  ...russianMessages,
  usermenu: {
    login: "Войти",
  },
  ra: {
    ...russianMessages.ra,
    configurable: {
      customize: "Кастомизировать",
    },
    page: {
      ...russianMessages.ra.page,
      empty: 'Нет записей в таблице "%{name}"',
    },
    action: {
      ...russianMessages.ra.action,
      clear_array_input: "Очистить все",
      move_up: "Поднять",
      move_down: "Опустить",
    },
    message: {
      ...russianMessages.ra.message,
      clear_array_input: "Все элементы будут удалены",
    },
  },
  login: {
    login: "Вход",
    signIn: "Вход",
    signUp: "Регистрация",
    registrationInvitation: "Еще не зарегестрированы?",
    signInError: "Неверный логин или пароль",
    form: {
      email: {
        label: "Email",
        errors: {
          email: "Неправильный email",
          maxLength: "Email должен быть короче 60 символов",
        },
      },
      password: {
        label: "Пароль",
        errors: {
          regex:
            "Пароль должен состоять из цифр и букв, быть длинее 8 символов и короче 16",
        },
      },
    },
  },
  resources: {
    users: {
      name: "Пользователь |||| Пользователи",
      fields: {
        password: "Пароль",
        role: "Роль",
      },
    },
    mainPage: {
      name: "Настройки главной",
    },
    socials: {
      name: "Социальные сети",
    },
    banners: {
      name: "Баннеры",
    },
    benefits: {
      name: '"Преимущества"',
    },
    forms: {
      name: "Описание услуги",
    },
    services: {
      name: "Страницы услуг",
    },
    layout: {
      name: "Layout",
    },
    faq: {
      name: "FAQ",
    },
    about: {
      name: '"О нас"',
    },
    popular: {
      name: '"Популярные проблемы"',
    },
  },
  mainPage: {
    name: "Главная страница",
    title: "Название",
    banner: "Выберите баннер из списка",
    about: 'Выберите секцию "О нас" из списка',
    benefits: 'Выберите секцию "Преимущества" из списка',
    popular: 'Выберите секцию "Популярные проблемы" из списка',
  },
  socials: {
    title: "Название",
    link: "Ссылка",
  },
  banners: {
    title: "Заголовок",
    subtitle: "Подзаголовок",
    slogans: "Слоганы",
    slogan: "Слоган",
  },
  benefits: {
    title: "Заголовок",
    subtitle: "Подзаголовок",
    description: "Описание",
    benefits: "Преимущества",
    benefitTitle: "Заголовок",
    benefitDescription: "Описание",
  },
  forms: {
    video: "Id видео",
    title: "Заголовок",
    subtitle: "Подзаголовок",
    description: "Описание",
    article: "Описание альтернативных услуг",
    extraButtons: "Доп кнопки",
    buttonTitle: "Название кнопки",
    buttonLink: "Ссылка на услугу",
  },
  services: {
    cover: "Обложка",
    banner: "Баннер",
    forms: "Описание услуги",
    form: "Выберите описние услуги из списка",
    serviceName: "Название услуги",
    coverTitle: "Заголовок обложки",
    coverSubTitle: "Подзаголовок обложки",
    mainPriceTitle: "Заголовок ценника",
    mainPriceSubtitle: "Подзаголовок ценника",
    prices: "Цены",
    categoryTitle: "Категория",
    priceList: "Список цен",
    name: "Название услуги",
    price: "Стоимость услуги",
  },
  layout: {
    phone: "Телефон",
    email: "E-mail",
    copyright: "Copyright",
    slogan: "Слоган",
    options: "Избранные услуги",
    option: "Название услуги",
    link: "Ссылка на услугу",
  },
  faq: {
    banner: "Баннер",
    title: "Заголовок",
    subtitle: "Подзаголовок",
    questions: "Вопросы и ответы",
    question: "Вопрос",
    answer: "Ответ",
  },
  about: {
    title: "Заголовок",
    subtitle: "Подзаголовок",
    description: "Описание",
    companyInfo: "Информация о компании",
    optionTitle: "Заголовок",
    optionDescription: "Описание",
  },
  popular: {
    title: "Заголовок",
    subtitle: "Подзаголовок",
    description: "Описание",
    services: "Список услуг",
    problem: "Проблема",
    service: "Ссылка на услугу",
  },
  menuGroups: {
    templates: "Шаблоны",
    modules: "Модули",
  },
  creators: {
    tabs: {
      form: "Редактирование",
      preview: "Предпросмотр",
    },
  },
  imageCrop: {
    title: "Кадрирование и размер изображения",
    open: "Кадрировать / изменить размер",
    mouseHint:
      "Перетащите рамку, чтобы выбрать фрагмент; тяните за углы, чтобы изменить её размер (пропорции сохраняются).",
    mouseHintFree:
      "Перетащите рамку, чтобы выбрать фрагмент; тяните за углы или края, чтобы изменить её размер.",
    size: "Итоговый размер",
    width: "Ширина",
    height: "Высота",
    lockedAspect: "Пропорции 1:1 — иконка на сайте квадратная",
    invalidSize: "Укажите целое число от 1 до %{max} px",
    sourceSize: "Оригинал: %{width}×%{height} px",
    areaSize: "выделенная область: %{width}×%{height} px",
    upscaleWarning:
      "Выделенная область меньше итогового размера — изображение будет увеличено и может потерять чёткость.",
    renderError: "Не удалось обрезать изображение: %{error}",
    loadError: "Не удалось загрузить изображение для кадрирования: %{error}",
    apply: "Применить",
    keepOriginal: "Оставить без кадрирования",
    currentSize: "Размер: %{width}×%{height} px",
    cropped: "Кадрировано",
    serverResizeHint:
      "Без кадрирования сервер обрежет изображение до %{width}×%{height} px (по центру)",
    presets: {
      standard: "Стандарт 16:9",
      bannerDesktop: "Широкий баннер",
      photo43: "Фото 4:3",
      square: "Квадрат",
      serviceCard: "Карточка услуги",
      icon: "Иконка",
      iconRetina: "Иконка HD",
      custom: "Свой размер",
      free: "Произвольная рамка",
    },
  },
  errors: {
    notFound: "Запись не найдена",
    unauthorized: "Требуется вход в систему",
    noHasPermissions: "Недостаточно прав для этого действия",
    invalidRequest: "Некорректные данные формы",
  },
  customErrors: {
    invalidEmailOrPassword: "Неверный email или пароль",
  },
  servicesReorder: {
    menu: "Изменить порядок",
    title: "Порядок страниц услуг",
    subtitle:
      "Перетаскивайте услуги, чтобы изменить их порядок в карусели и выпадающих списках на сайте.",
    saving: "Сохранение...",
    notifications: {
      success: "Порядок сохранён",
      error: "Не удалось сохранить порядок",
      loadError: "Не удалось загрузить список услуг",
    },
  },
  preview: {
    menu: "Конструктор страницы услуги",
    title: "Конструктор страницы услуги",
    subtitle:
      "Создайте баннер, описания услуг и саму услугу в одной форме, без переключения между разделами.",
    sections: {
      service: "Услуга",
      banner: "Баннер",
      forms: "Описания услуги (блоки заказа)",
    },
    metaHint:
      "Эти поля не отображаются на странице — используются для заголовка вкладки и SEO.",
    serviceCard: "Карточка услуги в карусели (350×250 px)",
    save: "Сохранить страницу услуги",
    saveExisting: "Сохранить изменения",
    selector: {
      label: "Существующая страница услуги",
      new: "Новая страница услуги",
    },
    notifications: {
      success: "Страница услуги сохранена",
      error: "Ошибка сохранения: %{error}",
      loadError: "Не удалось загрузить страницу услуги: %{error}",
      partial:
        "Частично создано: баннер (%{banner}), описания услуги (%{forms}). Исправьте данные и сохраните снова, либо доделайте вручную в разделах Баннеры/Описание услуги/Страницы услуг.",
    },
  },
  mainPageCreator: {
    menu: "Конструктор главной страницы",
    title: "Конструктор главной страницы",
    subtitle:
      "Создайте баннер, секции «О нас», «Преимущества» и «Популярные проблемы» в одной форме, без переключения между разделами.",
    save: "Сохранить главную страницу",
    saveExisting: "Сохранить изменения",
    selector: {
      label: "Существующая главная страница",
      new: "Новая главная страница",
    },
    notifications: {
      success: "Главная страница сохранена",
      error: "Ошибка сохранения: %{error}",
      loadError: "Не удалось загрузить главную страницу: %{error}",
    },
  },
  faqCreator: {
    menu: "Конструктор FAQ",
    title: "Конструктор FAQ",
    subtitle:
      "Создайте баннер и вопросы FAQ в одной форме, без переключения между разделами.",
    save: "Сохранить страницу FAQ",
    saveExisting: "Сохранить изменения",
    selector: {
      label: "Существующая страница FAQ",
      new: "Новая страница FAQ",
    },
    notifications: {
      success: "Страница FAQ сохранена",
      error: "Ошибка сохранения: %{error}",
      loadError: "Не удалось загрузить страницу FAQ: %{error}",
    },
  },
};

export const i18nProvider = polyglotI18nProvider(
  // @ts-ignore
  (locale) => (locale === "ru" ? newRussianMessages : newPolishMessages),
  "pl" // Default locale
);
